<template>
  <div>
    <el-dialog
      title="系统提示"
      width="495px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="tip-box">
        <i class="el-icon-warning warning-icon"></i>
        <span>请填写您的联系方式，以便接收店铺营销数据、异常信息通知</span>
      </div>
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input placeholder="请输入..." v-model="phone" style="width: 280px"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
            <el-button type="primary" :disabled="codeDisabled" @click="getCode">{{ codeMsg }}</el-button>
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <el-button type="primary" @click="savePhone">立即保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkCodeSet, updateSellerSetting } from "@/api/userInform"; //判断
export default {
  name: "",
  data() {
    return {
      visible: true,
      // visible: false,
      phone: "",
      code: "",
      timer: null, //验证码定时
      successMsg: "",
      countdown: 60, // 倒计时s
      codeMsg: "获取验证码", // 按钮上的文字
      saveDisable: false,
    };
  },
  mounted() {},
  methods: {
    /**  保存  */
    savePhone() {
      if (!this.phone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      var param = {
        mobile: this.phone,
        vcode: this.code,
      };
      updateSellerSetting(param).then((res) => {
        if (res.code == "1" || res.isFirst === 0 || res.isFirst === 1) {
          this.$message.success(res.message);
          this.$emit("close");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 获取验证码 */
    getCode() {
      if (!this.phone) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$message("手机号码有误,请重填");
        return false;
      }
      if (this.phone.length < 11) {
        this.$message("手机号码有误,请重填");
        return false;
      }

      if (!this.timer) {
        let obj = {
          bindingPhone: this.phone,
        };
        this.codeDisabled = true;
        checkCodeSet(obj).then((res) => {
          if (res.code == 1) {
          } else {
            this.$message.error(res.message);
          }
        });

        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = "重新发送(" + this.countdown + ")";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "获取验证码";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  // margin-top: 12px;
  color: #999999;
  background: #fafafa;
  position: relative;
  // margin: 20px 28px 20px 28px;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}
</style>
